var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 386,
    viewBox: "0 0 390 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_1151)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_373_1151)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 177.5,
    r: 111.5,
    fill: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.318 134.363C319.825 131.491 318.082 127.957 314.678 126.583C314.291 126.415 313.892 126.273 313.486 126.158L134.775 80.5869C131.336 79.7054 129.282 78.637 126.763 81.2946C125.409 82.7207 124.792 84.6071 124.449 86.4589C123.713 90.4684 123.451 92.6634 123.221 93.771C120.25 108.114 113.705 111.732 104.916 111.639C97.665 111.566 90.3543 110.055 90.3543 110.055L80.6318 247.2C80.6318 247.2 255.678 311.975 258.578 312.662C260.439 313.104 264.297 313.867 266.259 313.577C271.274 312.825 275.064 310.541 277.435 308.086C281.504 303.874 284.427 299.617 286.542 294.679C288.991 288.939 290.96 282.741 292.127 276.636L319.318 134.363Z",
    fill: "url(#paint0_linear_373_1151)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.122 276.625C290.952 282.735 288.987 288.927 286.537 294.665C284.428 299.603 281.497 303.863 277.427 308.073C275.06 310.527 271.267 312.814 266.251 313.562C264.292 313.858 260.434 313.096 258.568 312.647C258.337 312.599 257.02 312.134 254.785 311.332C228.959 302.08 80.6241 247.194 80.6241 247.194L90.3482 110.049C90.3482 110.049 97.6501 111.562 104.908 111.63C113.694 111.722 120.241 108.106 123.212 93.7629C123.442 92.6554 123.708 90.463 124.443 86.4515C124.785 84.5993 125.4 82.7142 126.755 81.2885C129.274 78.6377 131.325 79.7087 134.767 80.5807C139.038 81.6669 312.32 125.854 313.478 126.15C313.62 126.184 313.76 126.227 313.896 126.277C314.105 126.348 314.355 126.445 314.679 126.576C318.09 127.96 319.832 131.488 319.319 134.358L292.122 276.625Z",
    fill: "url(#paint1_linear_373_1151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.922 120.95C303.571 108.498 314.004 95.1374 327.95 89.2173C330.768 88.0219 334.592 86.5835 337.106 85.2169C331.696 83.8356 325.251 82.6322 319.793 81.4423L237.248 63.446L209.304 57.3539C198.429 54.984 186.51 64.3447 179.366 71.5151C171.304 79.6134 165.195 89.4808 160.101 99.6451C153.192 113.423 130.025 183.297 127.432 189.641C122.858 200.87 113.04 218.133 98.2972 214.089C104.202 215.762 215.047 248.059 223.697 250.504C233.788 253.356 241.986 247.045 247.796 239.388C254.915 230.002 268.935 184.661 272.849 172.986C276.78 161.289 292.471 126.574 295.922 120.95Z",
    fill: "url(#paint2_linear_373_1151)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.922 120.95C303.571 108.498 314.004 95.1374 327.95 89.2173C330.768 88.0219 334.592 86.5835 337.106 85.2169C331.696 83.8356 325.251 82.6322 319.793 81.4423L237.248 63.446L209.304 57.3539C198.429 54.984 186.51 64.3447 179.366 71.5151C171.304 79.6134 165.195 89.4808 160.101 99.6451C153.192 113.423 130.025 183.297 127.432 189.641C122.858 200.87 113.04 218.133 98.2972 214.089C104.202 215.762 215.047 248.059 223.697 250.504C233.788 253.356 241.986 247.045 247.796 239.388C254.915 230.002 268.935 184.661 272.849 172.986C276.78 161.289 292.471 126.574 295.922 120.95Z",
    fill: "url(#paint3_linear_373_1151)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.787 257.457C246.363 254.896 250.393 251.256 253.669 247.246C258.34 241.525 261.871 234.66 264.677 227.852C270.763 213.086 274.928 197.564 279.821 182.378C282.414 174.334 285.116 166.316 288.14 158.424C292.068 148.167 296.558 138.04 301.92 128.449C307.415 118.618 314.483 108.149 323.892 101.692C328.059 98.8343 332.501 96.9353 337.253 96.2557C340.348 95.8111 341.714 92.8116 341.381 90.04C341.048 87.2684 338.779 84.7975 335.834 85.2139C330.584 85.9614 325.455 88.1779 320.526 91.5133C309.35 99.0778 300.753 110.755 293.925 122.214C287.858 132.395 282.88 143.392 278.629 154.449C275.529 162.532 272.752 170.754 270.095 178.995C266.359 190.587 262.841 202.258 258.916 213.789C255.914 222.609 252.308 232.178 246.51 239.577C244.193 242.533 240.403 245.567 236.275 247.604L241.787 257.457Z",
    fill: "url(#paint4_linear_373_1151)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.397 91.0009C290.046 78.5486 300.479 65.1864 314.425 59.2679C317.243 58.0725 321.067 56.6342 323.58 55.2675C318.171 53.8863 311.725 52.6829 306.268 51.4929L223.723 33.4967L195.781 27.3932C184.904 25.0298 172.986 34.3905 165.839 41.5655C157.779 49.6589 151.669 59.5263 146.576 69.6906C139.666 83.4665 116.5 153.341 113.906 159.685C109.333 170.914 99.5142 188.178 84.7718 184.133C90.6766 185.808 201.521 218.104 210.171 220.549C220.263 223.4 228.46 217.09 234.271 209.434C241.389 200.046 255.409 154.705 259.323 143.032C263.257 131.335 278.948 96.6164 282.397 91.0009Z",
    fill: "url(#paint5_radial_373_1151)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.397 91.0009C290.046 78.5486 300.479 65.1864 314.425 59.2679C317.243 58.0725 321.067 56.6342 323.58 55.2675C318.171 53.8863 311.725 52.6829 306.268 51.4929L223.723 33.4967L195.781 27.3932C184.904 25.0298 172.986 34.3905 165.839 41.5655C157.779 49.6589 151.669 59.5263 146.576 69.6906C139.666 83.4665 116.5 153.341 113.906 159.685C109.333 170.914 99.5142 188.178 84.7718 184.133C90.6766 185.808 201.521 218.104 210.171 220.549C220.263 223.4 228.46 217.09 234.271 209.434C241.389 200.046 255.409 154.705 259.323 143.032C263.257 131.335 278.948 96.6164 282.397 91.0009Z",
    fill: "url(#paint6_linear_373_1151)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M228.308 227.478C232.865 224.919 236.878 221.291 240.144 217.293C244.815 211.574 248.346 204.707 251.152 197.901C257.238 183.132 261.403 167.613 266.298 152.427C268.889 144.382 271.591 136.364 274.615 128.472C278.543 118.214 283.034 108.088 288.395 98.4972C293.89 88.6666 300.958 78.1976 310.368 71.7384C314.535 68.8812 318.978 66.9842 323.729 66.3025C326.823 65.8596 328.19 62.8601 327.858 60.0888C327.527 57.3176 325.254 54.8461 322.309 55.2608C317.06 56.0082 311.932 58.2267 307.002 61.5602C295.825 69.1263 287.23 80.8026 280.4 92.2628C274.334 102.444 269.355 113.44 265.105 124.496C262.004 132.58 259.227 140.803 256.571 149.041C252.834 160.635 249.316 172.306 245.393 183.838C242.383 192.656 238.785 202.227 232.986 209.624C230.732 212.499 227.089 215.444 223.099 217.472L228.308 227.478Z",
    fill: "url(#paint7_linear_373_1151)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.74 195.033L169.198 169.222C165.314 168.208 162.31 165.295 161.448 161.707L154.36 132.248C153.496 128.659 150.492 125.747 146.608 124.733L90.2491 110.012C88.3701 109.531 86.8531 111.039 85.9212 112.266C84.8409 113.688 84.2027 115.382 83.8936 117.102C83.8925 117.112 83.8906 117.121 83.8879 117.13L63.9113 226.935C62.7849 233.138 62.5277 239.591 63.9423 245.869C64.5672 248.644 65.525 251.409 67.0552 253.917C68.8038 256.78 71.6265 259.508 75.1536 260.499L80.4194 261.996L94.6912 266.054L115.678 272.02L141.093 279.259L168.641 287.089L196.039 294.878L221.001 301.974L241.238 307.726L254.464 311.481L258.566 312.647L267.74 195.033Z",
    fill: "url(#paint8_linear_373_1151)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M258.276 312.567C258.276 312.567 255.736 311.844 254.468 311.49C250.059 310.232 245.651 308.98 241.243 307.735C234.496 305.818 227.75 303.9 221.005 301.983L196.044 294.885L168.643 287.1L141.094 279.259C132.623 276.848 124.153 274.44 115.682 272.036C108.69 270.046 101.696 268.058 94.7003 266.071L80.4253 262.012C78.6682 261.516 76.9131 261.017 75.1598 260.514C71.6272 259.516 68.8061 256.789 67.0613 253.931C65.5276 251.425 64.5697 248.659 63.9452 245.883C62.5323 239.605 62.7882 233.151 63.9123 226.95L83.8908 117.144L83.8962 117.118C84.202 115.397 84.8416 113.705 85.9248 112.277C86.8544 111.052 88.3694 109.546 90.2484 110.027L144.737 124.252L146.609 124.74C150.496 125.756 153.499 128.667 154.364 132.254L161.45 161.715C162.312 165.301 165.318 168.217 169.201 169.228L169.447 169.292L267.859 195.065L258.276 312.567Z",
    fill: "url(#paint9_linear_373_1151)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M292.122 276.625C290.953 282.734 288.987 288.926 286.538 294.665C284.428 299.602 281.498 303.862 277.427 308.072C275.06 310.526 271.268 312.813 266.251 313.562C264.293 313.858 260.434 313.096 258.569 312.647C258.337 312.599 257.211 312.441 255.209 311.174C254.135 310.493 253.067 309.278 251.97 307.74C248.733 303.179 247.736 297.708 247.44 292.47C247.179 287.806 247.52 283.127 248.456 278.55L262.227 202.527C262.669 200.193 264.001 193.967 267.862 195.059C271.829 196.184 278.992 199.479 287.608 195.377C296.403 191.182 302.946 162.788 304.013 157.24L308.482 133.812C308.933 131.453 310.59 125.739 313.898 126.272C314.106 126.342 314.356 126.44 314.681 126.571C318.091 127.954 319.834 131.483 319.32 134.353L292.122 276.625Z",
    fill: "url(#paint10_linear_373_1151)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.122 276.625C290.953 282.734 288.987 288.926 286.538 294.665C284.428 299.602 281.498 303.862 277.427 308.072C275.06 310.526 271.268 312.813 266.251 313.562C264.293 313.858 260.434 313.096 258.569 312.647C258.337 312.599 257.211 312.441 255.209 311.174C254.135 310.493 253.067 309.278 251.97 307.74C248.733 303.179 247.736 297.708 247.44 292.47C247.179 287.806 247.52 283.127 248.456 278.55L262.227 202.527C262.669 200.193 264.001 193.967 267.862 195.059C271.829 196.184 278.992 199.479 287.608 195.377C296.403 191.182 302.946 162.788 304.013 157.24L308.482 133.812C308.933 131.453 310.59 125.739 313.898 126.272C314.106 126.342 314.356 126.44 314.681 126.571C318.091 127.954 319.834 131.483 319.32 134.353L292.122 276.625Z",
    fill: "url(#paint11_radial_373_1151)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_1151",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 109,
    width: 206,
    height: 204
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267.74 195.033L169.198 169.222C165.314 168.208 162.31 165.295 161.448 161.707L154.36 132.248C153.496 128.659 150.492 125.747 146.608 124.733L90.2491 110.012C88.3701 109.531 86.8531 111.039 85.9212 112.266C84.8409 113.688 84.2027 115.382 83.8936 117.102C83.8925 117.112 83.8906 117.121 83.8879 117.13L63.9113 226.935C62.7849 233.138 62.5277 239.591 63.9423 245.869C64.5672 248.644 65.525 251.409 67.0552 253.917C68.8038 256.78 71.6265 259.508 75.1536 260.499L80.4194 261.996L94.6912 266.054L115.678 272.02L141.093 279.259L168.641 287.089L196.039 294.878L221.001 301.974L241.238 307.726L254.464 311.481L258.566 312.647L267.74 195.033Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_1151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.686 135.856C148.743 75.7962 139.671 22.3163 114.421 16.4052C89.1719 10.494 57.3072 54.39 43.2496 114.45C29.1919 174.509 38.2646 227.989 63.514 233.9C88.7634 239.812 120.628 195.916 134.686 135.856Z",
    fill: "url(#paint12_radial_373_1151)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164.509 168.081C160.175 166.98 154.34 163.933 153.189 159.178L144.734 124.246L146.607 124.734C150.494 125.75 153.497 128.661 154.362 132.248L161.448 161.709C162.31 165.295 165.315 168.211 169.198 169.222C169.198 169.222 167.218 168.766 164.509 168.081Z",
    fill: "url(#paint13_linear_373_1151)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.244 62.1046L196.198 62.0309C192.434 56.0083 180.067 54.7872 175.007 60.7372C173.713 62.2786 172.996 64.1055 172.57 65.9451C172.469 66.3725 172.487 67.281 172.083 67.5913C171.758 67.8386 171.237 67.5986 170.893 67.6288C168.974 67.7945 168.34 70.0968 168.171 71.5601C167.989 73.2509 168.121 75.064 168.77 76.5227C169.014 77.0807 169.656 78.0593 170.515 77.615C170.667 77.5364 170.986 77.1612 171.164 77.3605C171.438 77.6709 171.373 78.2713 171.437 78.6803C171.623 79.9756 172.103 81.2109 172.841 82.2911C173.121 82.6872 172.939 83.2771 172.454 83.5486C170.717 84.5148 168.857 85.24 166.925 85.7043C165.039 86.1523 163.101 86.3419 161.164 86.2681C160.944 86.2618 160.726 86.3216 160.539 86.4399C160.352 86.5582 160.205 86.7295 160.116 86.932C159.038 89.5837 157.476 93.2259 156.007 96.9805C155.072 99.3811 156.62 101.363 158.725 101.866L184.511 108.027C186.613 108.53 189.213 107.54 189.98 105.101C191.177 101.282 192.226 97.52 193.033 94.8003C193.094 94.6033 193.081 94.3909 192.998 94.2026C192.914 94.0142 192.765 93.8626 192.578 93.7758C190.931 93.0095 189.413 91.9921 188.078 90.76C186.757 89.5339 185.648 88.0966 184.798 86.5068C184.745 86.3942 184.716 86.272 184.713 86.1479C184.709 86.0237 184.731 85.9001 184.777 85.7847C184.823 85.6693 184.892 85.5645 184.98 85.4767C185.068 85.3888 185.172 85.3199 185.288 85.274C186.723 84.6536 188.014 83.7423 189.08 82.5977C189.315 82.3437 189.604 81.8354 190.02 81.8284C190.481 81.8192 190.553 82.7287 191.156 82.7149C192.162 82.6918 193.039 81.8858 193.708 81.2651C194.627 80.4239 195.432 79.4676 196.106 78.4199C196.937 77.1157 198.108 74.4663 196.324 73.6316C196.048 73.5018 195.64 73.5627 195.459 73.2663C195.207 72.8489 195.697 72.2858 195.908 71.9102C197.667 68.7398 198.051 65.1426 196.244 62.1046Z",
    fill: "#9EC9D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.532 60.8914L195.486 60.8177C191.723 54.7952 179.355 53.5741 174.295 59.524C172.988 61.0628 172.281 62.8865 171.85 64.7286C171.751 65.158 171.769 66.0648 171.365 66.3768C171.04 66.6241 170.519 66.3841 170.175 66.4143C168.255 66.5797 167.621 68.8803 167.451 70.3436C167.27 72.0361 167.401 73.8492 168.051 75.3082C168.296 75.8662 168.938 76.8448 169.797 76.4005C169.949 76.3219 170.268 75.9467 170.445 76.1457C170.719 76.4544 170.655 77.0568 170.719 77.4658C170.904 78.7609 171.384 79.9961 172.122 81.0762C172.401 81.4724 172.221 82.0626 171.736 82.3341C169.999 83.2994 168.139 84.0246 166.207 84.4898C164.321 84.9379 162.383 85.127 160.447 85.0519C160.225 85.046 160.008 85.1061 159.82 85.2246C159.633 85.3431 159.486 85.5145 159.396 85.7172C158.318 88.3688 156.756 92.0111 155.287 95.7656C154.352 98.1662 155.9 100.148 158.006 100.652L183.785 106.811C185.887 107.314 188.485 106.324 189.254 103.885C190.451 100.064 191.5 96.3039 192.307 93.5825C192.367 93.3844 192.353 93.1714 192.268 92.983C192.182 92.7946 192.032 92.6436 191.844 92.558C190.197 91.7913 188.679 90.774 187.344 89.5421C186.026 88.3136 184.92 86.8748 184.073 85.2841C184.02 85.1715 183.992 85.0494 183.988 84.9252C183.985 84.801 184.007 84.6775 184.052 84.5621C184.098 84.4466 184.167 84.3418 184.255 84.254C184.343 84.1662 184.448 84.0972 184.563 84.0513C185.998 83.4308 187.288 82.5194 188.353 81.3747C188.59 81.121 188.879 80.6127 189.294 80.6038C189.755 80.5962 189.827 81.5057 190.429 81.4919C191.438 81.4691 192.314 80.6631 192.984 80.0424C193.905 79.2032 194.716 78.2491 195.395 77.2035C196.226 75.8993 197.397 73.2499 195.613 72.4136C195.336 72.2851 194.928 72.346 194.746 72.0496C194.495 71.6305 194.986 71.0694 195.196 70.6934C196.957 67.527 197.339 63.9295 195.532 60.8914Z",
    fill: "url(#paint14_linear_373_1151)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.532 60.8914L195.486 60.8177C191.723 54.7952 179.355 53.5741 174.295 59.524C172.988 61.0628 172.281 62.8865 171.85 64.7286C171.751 65.158 171.769 66.0648 171.365 66.3768C171.04 66.6241 170.519 66.3841 170.175 66.4143C168.255 66.5797 167.621 68.8803 167.451 70.3436C167.27 72.0361 167.401 73.8492 168.051 75.3082C168.296 75.8662 168.938 76.8448 169.797 76.4005C169.949 76.3219 170.268 75.9467 170.445 76.1457C170.719 76.4544 170.655 77.0568 170.719 77.4658C170.904 78.7609 171.384 79.9961 172.122 81.0762C172.401 81.4724 172.221 82.0626 171.736 82.3341C169.999 83.2994 168.139 84.0246 166.207 84.4898C164.321 84.9379 162.383 85.127 160.447 85.0519C160.225 85.046 160.008 85.1061 159.82 85.2246C159.633 85.3431 159.486 85.5145 159.396 85.7172C158.318 88.3688 156.756 92.0111 155.287 95.7656C154.352 98.1662 155.9 100.148 158.006 100.652L183.785 106.811C185.887 107.314 188.485 106.324 189.254 103.885C190.451 100.064 191.5 96.3039 192.307 93.5825C192.367 93.3844 192.353 93.1714 192.268 92.983C192.182 92.7946 192.032 92.6436 191.844 92.558C190.197 91.7913 188.679 90.774 187.344 89.5421C186.026 88.3136 184.92 86.8748 184.073 85.2841C184.02 85.1715 183.992 85.0494 183.988 84.9252C183.985 84.801 184.007 84.6775 184.052 84.5621C184.098 84.4466 184.167 84.3418 184.255 84.254C184.343 84.1662 184.448 84.0972 184.563 84.0513C185.998 83.4308 187.288 82.5194 188.353 81.3747C188.59 81.121 188.879 80.6127 189.294 80.6038C189.755 80.5962 189.827 81.5057 190.429 81.4919C191.438 81.4691 192.314 80.6631 192.984 80.0424C193.905 79.2032 194.716 78.2491 195.395 77.2035C196.226 75.8993 197.397 73.2499 195.613 72.4136C195.336 72.2851 194.928 72.346 194.746 72.0496C194.495 71.6305 194.986 71.0694 195.196 70.6934C196.957 67.527 197.339 63.9295 195.532 60.8914Z",
    fill: "url(#paint15_radial_373_1151)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.394 88.5594L223.567 82.6259C221.255 82.0742 219.986 79.9105 220.735 77.796C221.483 75.6796 223.972 74.4077 226.276 74.9645L251.098 80.897C253.41 81.4487 254.679 83.6125 253.929 85.7285C253.187 87.8443 250.706 89.1127 248.394 88.5594Z",
    fill: "#729EB1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M258.163 103.724L205.433 91.122C203.121 90.5703 201.855 88.4069 202.602 86.2905C203.351 84.1761 205.839 82.9022 208.144 83.461L260.874 96.0615C263.186 96.6149 264.453 98.7766 263.705 100.893C262.956 103.009 260.478 104.277 258.163 103.724Z",
    fill: "#729EB1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M243.079 129.541L198.966 118.999C197.155 118.566 196.162 116.873 196.749 115.215C197.334 113.559 199.276 112.566 201.094 113L245.207 123.543C247.018 123.976 248.011 125.67 247.424 127.326C246.836 128.981 244.893 129.974 243.079 129.541Z",
    fill: "#9EC9D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M239.24 141.281L195.127 130.739C193.316 130.307 192.323 128.613 192.91 126.957C193.496 125.299 195.438 124.306 197.255 124.74L241.368 135.283C243.179 135.716 244.172 137.41 243.585 139.066C242.992 140.72 241.05 141.713 239.24 141.281Z",
    fill: "#9EC9D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M235.627 152.787L191.514 142.245C189.704 141.813 188.712 140.119 189.297 138.461C189.883 136.805 191.826 135.812 193.642 136.246L237.755 146.789C239.565 147.221 240.557 148.915 239.971 150.571C239.379 152.226 237.436 153.224 235.627 152.787Z",
    fill: "#9EC9D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.859 87.6483L223.037 81.7158C220.725 81.164 219.458 79.0007 220.206 76.8843C220.955 74.7682 223.442 73.4959 225.748 74.0547L250.57 79.9856C252.882 80.539 254.149 82.7007 253.402 84.8171C252.652 86.9332 250.171 88.2 247.859 87.6483Z",
    fill: "url(#paint16_linear_373_1151)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.631 102.812L204.9 90.2112C202.588 89.6578 201.321 87.4961 202.07 85.38C202.818 83.2636 205.307 81.9916 207.611 82.5485L260.342 95.151C262.654 95.7027 263.921 97.8661 263.173 99.9825C262.424 102.097 259.943 103.365 257.631 102.812Z",
    fill: "url(#paint17_linear_373_1151)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.023 116.814L200.292 104.213C197.98 103.66 196.713 101.497 197.461 99.3819C198.21 97.2658 200.697 95.9935 203.003 96.5507L255.733 109.153C258.044 109.706 259.311 111.87 258.564 113.984C257.815 116.099 255.335 117.366 253.023 116.814Z",
    fill: "#729EB1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M252.494 115.904L199.758 103.306C197.446 102.754 196.178 100.59 196.927 98.4742C197.675 96.3594 200.164 95.0858 202.468 95.6443L255.197 108.245C257.509 108.798 258.778 110.96 258.029 113.076C257.282 115.188 254.801 116.455 252.494 115.904Z",
    fill: "url(#paint18_linear_373_1151)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.439 128.441L198.326 117.9C196.515 117.467 195.523 115.773 196.109 114.115C196.696 112.459 198.637 111.466 200.454 111.9L244.567 122.443C246.379 122.876 247.371 124.57 246.785 126.226C246.192 127.881 244.249 128.873 242.439 128.441Z",
    fill: "url(#paint19_linear_373_1151)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M238.597 140.181L194.483 129.64C192.672 129.207 191.68 127.513 192.267 125.856C192.853 124.2 194.796 123.207 196.612 123.641L240.725 134.184C242.536 134.616 243.528 136.31 242.942 137.966C242.342 139.621 240.408 140.614 238.597 140.181Z",
    fill: "url(#paint20_linear_373_1151)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M234.983 151.687L190.87 141.146C189.06 140.713 188.068 139.019 188.653 137.361C189.239 135.705 191.182 134.713 192.998 135.146L237.111 145.689C238.921 146.122 239.913 147.816 239.328 149.472C238.736 151.125 236.793 152.119 234.983 151.687Z",
    fill: "url(#paint21_linear_373_1151)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.808 164.291L188.694 153.749C186.885 153.317 185.892 151.623 186.478 149.965C187.064 148.309 189.007 147.316 190.823 147.75L234.936 158.293C236.745 158.725 237.738 160.419 237.151 162.075C236.56 163.73 234.617 164.723 232.808 164.291Z",
    fill: "#9EC9D8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M232.163 163.191L188.049 152.65C186.24 152.217 185.247 150.523 185.833 148.865C186.419 147.209 188.362 146.217 190.178 146.65L234.291 157.193C236.1 157.626 237.093 159.32 236.508 160.976C235.915 162.631 233.972 163.623 232.163 163.191Z",
    fill: "url(#paint22_linear_373_1151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_373_1151",
    x: 25.7,
    y: 0.699997,
    width: 353.6,
    height: 353.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.65,
    result: "effect1_foregroundBlur_373_1151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_373_1151",
    x1: 77.5403,
    y1: 171.864,
    x2: 304.108,
    y2: 218.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A87F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#466BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3453FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#395BF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#4B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5789F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5F94F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#5F95F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5A8CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#527CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_373_1151",
    x1: 214.901,
    y1: 100.041,
    x2: 200.62,
    y2: 156.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#83BCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#83BCFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_373_1151",
    x1: 203.102,
    y1: 146.628,
    x2: 279.188,
    y2: 167.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#92BCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_373_1151",
    x1: 244.191,
    y1: 58.6261,
    x2: 192.622,
    y2: 241.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#CFEBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B4D8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#94BECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8AB3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_373_1151",
    x1: 371.194,
    y1: 104.47,
    x2: 202.419,
    y2: 237.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E6F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D9EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D1ECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFEBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BCDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#8AB3C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_373_1151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-181.728 4.05641) rotate(15.7127) scale(526.174 526.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C1E3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D7ECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E7F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F0F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EAF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D2EAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B1DAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A0CBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EC9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_373_1151",
    x1: 230.573,
    y1: 28.6251,
    x2: 179.003,
    y2: 211.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#92BCCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8AB3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_373_1151",
    x1: 357.571,
    y1: 74.474,
    x2: 188.844,
    y2: 207.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E6F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D9EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D1ECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CFEBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BCDBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#8AB3C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_373_1151",
    x1: 68.8947,
    y1: 189.474,
    x2: 275.234,
    y2: 232.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#72ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7FB8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#83BCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6EA6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5E90F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#5A87F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_373_1151",
    x1: 197.444,
    y1: 122.023,
    x2: 149.373,
    y2: 290.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#83BCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#74ACF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#69A1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#639AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5C8FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#4C6FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#496CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_373_1151",
    x1: 251.911,
    y1: 212.842,
    x2: 305.88,
    y2: 223.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5A87F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#496CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4C71FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#537FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6096F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#6198F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_373_1151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(288.83 122.812) rotate(11.7049) scale(191.963 192.137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4C6FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4C6FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C6FFA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_373_1151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.3697 125.137) rotate(13.1763) scale(46.6671 111.665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_373_1151",
    x1: 165.226,
    y1: 144.737,
    x2: 148.969,
    y2: 148.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#496CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#496CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_373_1151",
    x1: 171.633,
    y1: 56.1606,
    x2: 181.255,
    y2: 106.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3EC7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#27A0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2299A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#16848F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15838E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_373_1151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.632 62.9466) rotate(11.7049) scale(38.4631 38.498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_373_1151",
    x1: 239.826,
    y1: 73.1104,
    x2: 236.466,
    y2: 86.7175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE78F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C182FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CB88FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CF8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C080F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9864D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6945A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6C47AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#744EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8259CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9669EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_373_1151",
    x1: 235.778,
    y1: 84.7231,
    x2: 232.319,
    y2: 98.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE78F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C182FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CB88FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CF8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C080F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9864D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6945A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6C47AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#744EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8259CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9669EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_373_1151",
    x1: 230.67,
    y1: 97.8159,
    x2: 227.211,
    y2: 111.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A6CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AE78F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#C182FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#CB88FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CF8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C080F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#9864D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#6945A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6C47AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#744EB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8259CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9669EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A6CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_373_1151",
    x1: 222.341,
    y1: 116.555,
    x2: 220.616,
    y2: 123.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AAD4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B4DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ACD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8DB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_373_1151",
    x1: 218.438,
    y1: 128.376,
    x2: 216.849,
    y2: 135.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AAD4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B4DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ACD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8DB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_373_1151",
    x1: 214.881,
    y1: 139.77,
    x2: 213.042,
    y2: 147.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AAD4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B4DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ACD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8DB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_373_1151",
    x1: 212.061,
    y1: 151.274,
    x2: 210.221,
    y2: 158.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EC9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#AAD4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B4DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ACD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8DB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_1151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330,
    height: 325,
    fill: "white",
    transform: "translate(66.7324 0.660156) rotate(11.7049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.dd042f2de3d204ad0ea265b82829b2f1.svg";
export { ForwardRef as ReactComponent };